
const postResetZSX = () => {
  fetch(
    '/api/updatezsxs',
    { method: "POST" }
  )
    .then(res => {
      if (res.body.catalogoStatus == 200) {
        alert(`Success (${res.body.catalogoStatus})`)
      }
      else {
        alert(`${res.statusText || "WTF"} (${res.body.catalogoStatus})`)
      }
    })
    .catch(() => alert("ERROR (!?)"))
}

export default postResetZSX
